<template>
  <div>
    <div class="hcenter">
      <i style="margin-bottom: 10px" @click="back" class="el-icon-arrow-left"></i>
      <div style="width: 200px; margin-bottom: 10px; margin-right: 10px">
        <el-input :value="$route.query.purchasePlanName" disabled />
      </div>
      <SearchComponent
        :selectOrInputList="selectOrInputList"
        @on-search="handleSearch"
        @on-reset="handleReset"
        :authIdentity="authIdentity"
      ></SearchComponent>
    </div>

    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
      :cell-style="cellStyle"
    >
    <template slot="checkStatus" slot-scope="scope">
        <el-tag :type="getStatusColor(scope.data.checkStatus)">{{  getStatusText(scope.data.checkStatus) }}</el-tag>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-button class="button" type="text" size="small" @click="onOperat('preview', scope.data)">详情</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="operatDialog.title"
      :visible.sync="operatDialog.visible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="operatDialog.visible = false"
    >
      <component
        :ref="operatDialog.currentView"
        :is="operatDialog.currentView"
        :data="operatDialog.data"
        :type="operatDialog.type"
      ></component>
      <span slot="footer"> </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/procure/plan/components/form'
import Preview from './components/Preview'

import { getDrySkinReceiptDetail } from '@/api/manage/report'

import CONSTANT from '@/utils/statusConstants'

import { isDef } from '@/utils/is'
export default {
  name: 'skinDetail',
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
    Preview,
  },
  data() {
    const title = '入库验收'
    const _this = this
    return {
      authIdentity: 'process:drySkinReceipt',
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'dryPeelBizNo',
          label: '干皮批次',
          isTrue: true,
          width: 130,
        },
        {
          prop: 'status',
          label: '验收结果',
          width: '120',
          isTrue: true,
          formatter(row) {
            return isDef(row.status) ? row.status === 1 ? '达标' : '不达标' : '-'
          },
        },
        {
          prop: 'pickingBatchBizNo',
          label: '采摘批次',
          isTrue: true,
          width: 130,
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
          width: '120',
        },
        {
          prop: 'productName',
          label: '产品名称',
          isTrue: true,
        },
        {
          prop: 'productionArea',
          label: '产区',
          isTrue: true,
          width: '120',
        },
        {
          prop: 'pickingDateTime',
          label: '年份',
          width: '120',
          isTrue: true,
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'ripenessLevelSpecAttrValueKey',
          label: '成熟度',
          isTrue: true,
        },
        {
          prop: 'totalNetWeight',
          label: '应收总数量（斤）',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'fullRatedWeight',
          label: '满框定重（斤）',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'fullBasketCount',
          label: '满框框数',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'tailWeight',
          label: '尾框重量（斤）',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'totalBasketCount',
          label: '总框数',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'unacceptedNetWeight',
          label: '验收不达标总净重(斤)',
          isTrue: true,
          width: '100',
        },

        {
          prop: 'acceptedNetWeight',
          label: '可入库总净重（斤）',
          isTrue: true,
          width: '120',
        },
        {
          prop: 'storedNetWeight',
          label: '已入库总净重（斤）',
          isTrue: true,
          width: '120',
        },
        {
          prop: 'inventoryLocation',
          label: '仓库',
          isTrue: true,
          width: '90',
        },
        {
          prop: 'storageArea',
          label: '库区',
          width: '120',
          isTrue: true,
        },
        
        {
          prop: 'checkStatus',
          label: '单据状态',
          width: '120',
          isTrue: true,
          formSolt: true,
          // formatter(row) {
          //   return row.status === 1 ? '已验收' : '未验收'
          // },
        },
        {
          prop: 'createBy',
          label: '干皮记录员',
          width: '120',
          isTrue: true,
        },
        {
          prop: 'operatorName',
          label: '验收员',
          width: '120',
          isTrue: true,
        },
        {
          prop: 'inspectionTraceabilityNodeTime',
          label: '验收时间',
          width: '120',
          isTrue: true,
          formatter(row) {
            return _this.parseTime(row.inspectionTraceabilityNodeTime, '{y}-{m}-{d} {h}:{i}')
          },
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'status',
          placeholder: '请选择验收结果',
          class: 'home',
          type: 'select',
          value: 'id',
          label: 'label',
          list: [
            {
              id: 1,
              label: '达标'
            },
            {
              id: 0,
              label: '不达标'
            },
          ]
        },
        {
          model: 'checkStatus',
          placeholder: '请选择验收状态',
          class: 'home',
          type: 'select',
          value: 'value',
          label: 'label',
          list: CONSTANT.dryCheckStatus
        },
        {
          model: 'bizNo',
          placeholder: '请输入批次',
          class: 'home',
          type: 'input',
        },
        {
          model: 'plantationName',
          placeholder: '请输入果园名称',
          class: 'home',
          type: 'input',
        },
      ],

      // 弹窗数据
      operatDialog: {
        visible: false, // 是否展示
        title: '', // 弹窗标题
        currentView: null, //当前组件
        width: '', // 弹窗宽度
        type: '', // 提交类型
        data: {}, // 数据
      },

      // 弹窗枚举
      operatEnum: {
        add: () => {
          return {
            component: 'MForm',
            title: `新增${title}`,
            width: '75%',
          }
        },
        edit: () => {
          return {
            component: 'MForm',
            title: `修改${title}`,
            width: '75%',
          }
        },
        preview: () => {
          return {
            component: 'Preview',
            title: `查看${title}`,
            width: '75%',
          }
        },
        resubmit: () => {
          return {
            component: 'MFrom',
            title: `重新提交${title}`,
            width: '75%',
          }
        },
        submit: () => {
          return {
            component: 'Preview',
            title: `提交${title}`,
            width: '75%',
          }
        },
      },

      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getStatusText(checkStatus) {
     return CONSTANT.dryCheckStatus.find((item => item.value === checkStatus))?.label
    },
    getStatusColor(checkStatus) {
      return CONSTANT.dryCheckStatus.find((item => item.value === checkStatus))?.color
    },
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getDrySkinReceiptDetail({ ...this.queryParams, purchasePlanId: this.$route.query.purchasePlanId })
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              // item.visible = false
              // item.locName = this.formatLocal(item.locDetails, 3)
              // item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
              // item.statusText = CONSTANTS.getStatusConversion(item.status, 'taskStatus')
              // item.readyForHarvest = CONSTANTS.getStatusConversion(item.readyForHarvestStatus, 'readyForHarvestStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (
        isDef(row.status) &&
        row.status !== 1 &&
        [2].includes(columnIndex)
      ) {
        return {
          background: '#feeaea',
          color: 'red',
        }
      }
    },
    // 操作: add添加，edit编辑，import导入, export导出, print打印
    onOperat(type, row) {
      // 添加操作类型
      const { component, title, width } = this.operatEnum[type]()
      this.operatDialog.title = title
      this.operatDialog.width = width
      this.operatDialog.type = type
      this.operatDialog.data = row || {}

      this.operatDialog.currentView = component
      this.operatDialog.visible = true
    },
    summaryMethod(param) {
      const { columns, data } = param
      const sums = []

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 4) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalSettlementNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 5) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshPeelTotalNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 6) {
          const freshPeelTotalNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.freshPeelTotalNetWeight || 0), 2)
          }, 0)

          const totalSettlementNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalSettlementNetWeight || 0), 2)
          }, 0)

          sums[index] = !totalSettlementNetWeight
            ? totalSettlementNetWeight
            : this.myFixed((freshPeelTotalNetWeight / totalSettlementNetWeight) * 100, 2)
          return
        }
        if (index == 10) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 11) {
          const totalNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalNetWeight || 0), 2)
          }, 0)

          const totalSettlementNetWeight = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalSettlementNetWeight || 0), 2)
          }, 0)

          sums[index] = !totalSettlementNetWeight
            ? totalSettlementNetWeight
            : this.myFixed((totalNetWeight / totalSettlementNetWeight) * 100, 2)
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    back() {
      this.$router.back()
    },
    toDetail() {
      this.$router.push('/')
    },
    handlePrint(row) {
      this.printInfo.list = [row]

      this.printInfo.printDialog = true
      this.$nextTick(() => {
        this.$refs.printBox.init(this.printInfo)
      })
    },
    cancel() {
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '新增采购计划'
        this.currentView = 'myform'
        this.type = 'add'
      })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang="less">
// @import '../../../../assets/form.less';
@import '~@/assets/variables.less';
.el-icon-arrow-left {
  font-size: 30px;
  color: @theme-color;
  cursor: pointer;
}

.hcenter {
  display: flex;
  align-items: center;
}
</style>
